import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticipantLogsComponent } from './participant-logs.component';
import { HttpClient } from '@angular/common/http';
import { createTranslateLoader } from '../../../shared/http-loader-factory';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { CustomPipeModule } from '../../../shared/pipes/custom-pipe.module';
import { LoaderModule } from '../../../shared/components/loader/loader.module';
import { MatIconModule } from '@angular/material/icon';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ParticipantLogsComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    CustomPipeModule,
    MatIconModule,
    AngularSvgIconModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    LoaderModule,
    FormsModule,
    MatInput,
    MatFormField,
  ],
  exports: [ParticipantLogsComponent],
})
export class ParticipantLogsModule {}
